import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { Store } from "@ngrx/store";
import { IAppStore } from "../iappstore";
import { Observable } from "rxjs";
import { map, catchError, tap, switchMap } from "rxjs/operators";

import { BaseService } from "./base.service";


@Injectable()
export class UserDataImportService extends BaseService {
    /**
     * Constructor for service
     * @param http angular http module
     * @param toastr toastr manager
     * @param authService Authorization Service
     */
    constructor(httpClient: HttpClient, toastr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastr, store);
    }

    importFile(formData: FormData): Observable<Blob> {
        return super.postFileWithContent("api/userdataimport", formData)
            .pipe(map((r: Blob) => r));
    }
}




